module.exports = __webpack_public_path__ + "img/icon2.3a480a37.png";